import { ERooms } from '../types/filters';

export function getRoomsRange(filterRooms?: ERooms[]): ERooms[] {
  if (!filterRooms) {
    return [];
  }

  return filterRooms.includes(ERooms.FourRoom) ? [...filterRooms, ERooms.FiveRoom, ERooms.Large] : filterRooms;
}
